var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-gray-100 rounded-md px-3 py-2 d-flex" }, [
    !!_vm.index
      ? _c(
          "div",
          { staticClass: "text-mono text-gray-400 font-weight-bold pr-2" },
          [_vm._v(_vm._s(_vm.index))]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("strong", [_vm._v(_vm._s(_vm.channel.watchman.name))]),
        _vm._v(" "),
        _c("ChannelItem", { attrs: { channel: _vm.channel } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }